import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { MichiganDiceMultiplierAnimation } from './mi-dice-multiplier-animiation'

export const MI_MULTIPLIER_DICE_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: MichiganDiceMultiplierAnimation,
}
